module.exports = __webpack_public_path__ + "static/media/admin_img_centro_de_custo.d1eab970.svg";